import React from 'react';
import { Skeleton } from 'antd';

interface IProps {}

const ONE_ROW = 1;

export class CondoSearchSkeleton extends React.Component<IProps> {
  render(): React.ReactNode {
    return (
      <div className="condo-skeleton">
        <div className="condo-skeleton__items flex-row">
          <Skeleton
              className="condo-skeleton__filter"
              active
              title={false}
              paragraph={{ rows: ONE_ROW }}
            />
            <Skeleton
              className="condo-skeleton__filter"
              active
              title={false}
              paragraph={{ rows: ONE_ROW }}
            />
        </div>
      </div>
    );
  }
}
